import { render } from "./formdate.vue?vue&type=template&id=1d907234"
import script from "./formdate.vue?vue&type=script&lang=js"
export * from "./formdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__